import {
    URLAPI,
    CUSTODY_PATH,
    CUSTODY_CREATE_PATH,
    CUSTODY_REPORT_PATH,
    CUSTODY_DETAILS_PATH,
    CUSTODY_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_custody: {
        data: [],

        status: 0,
        message: {},
    },
    _create_custody: {
        data: {},
        status: 0,
        message: {},
    },
    _update_custody: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_CUSTODY = "GET_ALL_CUSTODY";
export const CREATE_CUSTODY = "CREATE_CUSTODY";
export const UPDATE_CUSTODY = "UPDATE_CUSTODY";
export const GET_REPORT = "GET_REPORT";

export const custody_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CUSTODY:
            return {
                ...state,
                _get_all_custody: action.payload,
            };
        case CREATE_CUSTODY:
            return {
                ...state,
                _create_custody: action.payload,
            };
        case UPDATE_CUSTODY:
            return {
                ...state,
                _update_custody: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllCustody = (token, page) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${CUSTODY_PATH}?page=${page}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_CUSTODY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_CUSTODY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemCustody = async (token, id) => {
    return await axios.get(`${URLAPI}${CUSTODY_DETAILS_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create custody
export const createCustody = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${CUSTODY_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_CUSTODY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_CUSTODY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateCustody = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${CUSTODY_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_CUSTODY,
            payload: {
                data: response.data,
                status: response.status,
                message: response.data.mensaje,
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_CUSTODY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_CUSTODY,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error en el servidor",
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + CUSTODY_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_custody = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
